import React from 'react';
import Icon from '@ant-design/icons';

const SvgIcon = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 39.952408 39.952412">
        <g
            id="layer1"
            transform="translate(-66.139513,-63.28187)">
            <rect
                style={{fill:'#000000',fillOpacity:1,stroke:'#000000',strokeWidth:1,strokeLinecap:'round',strokeLinejoin:'miter',strokeDasharray:'none',strokeOpacity:1,paintOrder:'markers'}}
                id="rect1514-3"
                width="22.841021"
                height="22.841024"
                x="74.601974"
                y="71.928368"
                ry="0" />
        </g>
    </svg>
);

const PatternSquareIcon = (props) => <Icon component={SvgIcon} {...props} />;

export default PatternSquareIcon